export default "__VITE_ASSET__51JG1dzY__"